<template>
    <div class="overlay-shadow" v-bind:class="{ active: isMenuMobileVisible || isModalEmailVisible || isModalUserVisible || isMenuUploadVisible || active }" v-on:click="hideMenuMobile"></div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "Shadow",
        props: {
            active: Boolean
        },
        computed: {
            ...mapState("application", ["isMenuUploadVisible", "isMenuMobileVisible", "isModalEmailVisible", "isModalUserVisible"])
        },
        methods: {
            ...mapMutations("application", ["hideMenuMobile"])
        }
    }
</script>

<style scoped>
    .overlay-shadow {
        position: fixed;
        visibility: hidden;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: 10;
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        filter: alpha(opacity=0);
        opacity: 0;

        -webkit-transition: opacity 0.4s ease, visibility 0.4s ease;
        -moz-transition: opacity 0.4s ease, visibility 0.4s ease;
        -ms-transition: opacity 0.4s ease, visibility 0.4s ease;
        -o-transition: opacity 0.4s ease, visibility 0.4s ease;
        transition: opacity 0.4s ease, visibility 0.4s ease;
    }
    .overlay-shadow.active {
        visibility: visible;
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
        filter: alpha(opacity=100);
        opacity: 1;
    }
</style>